export default {
  getTeacherClockRecordList: (state) => state.items,
  getTeacherClockRecordPagination: (state) => state.pagination,
  getTeacherClockRecordPage: (state) => state.pagination.current_page,
};
